function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import EBPropTypes from 'js-utils/prop-types';
import { getAdditionalProps } from '../utils/propTypes';
/**
 * The CSS property `object-fit: contain` isn't supported in IE at all.
 * But all target browsers support `background-size: contain`, which
 * behaves in the same way but only for background images.
 * This cross-browser polyfill uses an actual image tag AND a
 * background image.  The actual image tag is used for automatic
 * sizing of the container, so has its visibility set to hidden.  Sighted
 * user will actually be seeing a background-image applied to the
 * parent container so we can take advantage of `background-size: contain`.
 * Non-sighted users will still have the <img /> and alt attribute in
 * normal document flow.
 * This methodology tested in IE10 & IE11.
 */

var ObjectFitImage =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ObjectFitImage, _PureComponent);

  function ObjectFitImage() {
    _classCallCheck(this, ObjectFitImage);

    return _possibleConstructorReturn(this, _getPrototypeOf(ObjectFitImage).apply(this, arguments));
  }

  _createClass(ObjectFitImage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          imageSrc = _this$props.imageSrc,
          imageAlt = _this$props.imageAlt,
          imageClassName = _this$props.imageClassName,
          containerClassName = _this$props.containerClassName;
      var containerClasses = classNames('object-fit-image__container', containerClassName);
      var containerStyle = {
        backgroundImage: "url(".concat(imageSrc, ")")
      };
      var imageClasses = classNames('object-fit-image__image', 'eds-max-img', imageClassName);
      var extraAttrs = getAdditionalProps(this);
      return React.createElement("div", {
        className: containerClasses,
        style: containerStyle
      }, React.createElement("img", _extends({
        className: imageClasses,
        alt: imageAlt,
        src: imageSrc
      }, extraAttrs)));
    }
  }]);

  return ObjectFitImage;
}(PureComponent);

_defineProperty(ObjectFitImage, "propTypes", {
  /**
   * Source of the image to be displayed
   */
  imageSrc: PropTypes.string.isRequired,

  /**
   * Alt attribute of the actual image tag
   */
  imageAlt: EBPropTypes.translation.isRequired,

  /**
   * Any additional className to be applied to the image tag.
   * This should be used to set max-height and min-height.
   */
  imageClassName: PropTypes.string,

  /**
   * Any additional className to be applied to the container.
   */
  containerClassName: PropTypes.string
});

export { ObjectFitImage as default };